import gqlTagGira from 'graphql-tag';

export const FIELDS_LIMIT_QUERY = gqlTagGira`
    query addRequestTypeDropdownQuery($projectId: Long!) {
        projectConfiguration(projectId: $projectId) {
            ... on JiraProjectConfigurationResult {
                limitInfo {
                    limitFieldsPerProject
                    currentFieldsPerProject
                }
            }
        }
    }
`;
